import { MouseEvent } from "react";
import { Loader2, Square } from "lucide-react";
import { Button } from "../ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";
import { PermissionGate } from "../PermissionGate";

interface StopEventRunButtonProps {
  onClick: (e: MouseEvent) => void;
  isStopping: boolean;
}

/**
 * Stop-run affordance for an event-run row. Purely presentational — the
 * caller decides when to render it (only active-tier rows) and owns the
 * confirm-vs-immediate-stop branching. Lives in `components/audit` (rather
 * than a page-scoped directory) so both the workpaper run-log popover and
 * the sidebar background-tasks popover can import it.
 */
export const StopEventRunButton = ({
  onClick,
  isStopping,
}: StopEventRunButtonProps) => (
  <PermissionGate permission="run_test">
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-5 w-5 p-0"
          aria-label="Stop run"
          disabled={isStopping}
          onClick={onClick}
        >
          {/* Own spinner instead of the shared Button's `loading`: that one
              renders a 16px Loader2 + 8px margin ALONGSIDE the children,
              which overflows this 20px box. Swapping the Square for an
              identically-sized spinner keeps everything inside it. */}
          {isStopping ? (
            <Loader2 className="h-3.5 w-3.5 animate-spin" />
          ) : (
            <Square className="h-3.5 w-3.5" />
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent>Stop run</TooltipContent>
    </Tooltip>
  </PermissionGate>
);
